import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {InsoleMaterialModel} from "../../../api/entity/insoleMaterial.model";
import {InsoleMaterialConverter} from "../../../api/entity/insoleMaterial.converter";


@Injectable()
export class InsoleMaterialDataService extends AbstractDataServiceV2<InsoleMaterialModel, InsoleMaterialConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: InsoleMaterialConverter) {
        super('InsoleMaterial', http, httpUrlGenerator, logger, config, converter);
    }
}
